import { Body } from 'components/Typography';
import { twMerge } from 'tailwind-merge';
import { useConnection } from 'wagmi';
import { formatUnits } from 'utils/units';
import { DynaVault } from '../../../../api/DynaVaultsAPI';
import { formatTokenAmount, formatUsd } from '@dapp/multi-lib/lib/formatters';
import { useVaultOnChainData } from 'structure/pv2/dynavault/hooks/useVaultListBlockchain';

interface VaultPositionProps {
  className?: string;
  vault: DynaVault;
}

export const VaultPosition = (props: VaultPositionProps) => {
  const { className, vault } = props;

  const account = useConnection();

  const vaultOnChainData = useVaultOnChainData({
    vaultAddress: vault.address,
    chainId: vault.chainId,
    walletAddress: account.address as string,
  });

  const position = vaultOnChainData.data?.walletBalance || BigInt(0);

  // Convert vault price (in deposit token) to USD using oracle
  const vaultPriceInUsd = vaultOnChainData.data
    ? vaultOnChainData.data.vaultPrice
    : 0;

  const positionUsdc =
    parseFloat(formatUnits(position, vault.decimals)) * Number(vaultPriceInUsd);

  return (
    <div className={twMerge('flex flex-col items-end', className)}>
      <Body className='text-sm font-normal'>
        {formatTokenAmount(position, vault.decimals, 6)}
      </Body>
      <Body className='text-sm text-white-500'>${formatUsd(positionUsdc)}</Body>
    </div>
  );
};
